const startProductSlider = function () {

	const galleryThumbnail = new Swiper(".swiper.swiper__thumbnails", {
		slidesPerView: "auto",
		grabCursor: false,
		watchSlidesVisibility: true,
		spaceBetween: 8,
		watchSlidesProgress: true,
		watchOverflow: true,
		slideToClickedSlide: true,
		navigation: {
			nextEl: '.swiper__thumbnails-button-next',
			prevEl: '.swiper__thumbnails-button-prev',
		},
		threshold: 10,
		touchAngle: 30,
		direction: 'vertical'
	});

	const gallery = new Swiper('.swiper-product', {
			speed: 750,
			loop: !1,
			spaceBetween: 0,
			slidesPerView: 1,
			allowTouchMove: !0,
			pagination: {
				el: '.swiper-pagination'
			},
			thumbs: {
				swiper: galleryThumbnail,
			},
			breakpoints: {
				769: {
					spaceBetween: 1
				}
			}
		}
	);
	window.initImageLoad(), window.initVideoLoad();
}

document.addEventListener('DOMContentLoaded', () => {
	startProductSlider()
	document.querySelector('.section-product__slider').classList.add('section-product__slide--show')
})

window.addEventListener('resize', () => {
	const mainSwiperFirstSlide = document.querySelector('.swiper-product .swiper-slide');
	const thumbsSwiper = document.querySelector('.swiper__thumbnails');
	const thumbsSwiperWrapper = document.querySelector('.swiper__thumbnailsWrapper');

	thumbsSwiperWrapper.style.height = mainSwiperFirstSlide.scrollHeight + 'px';
	thumbsSwiper.style.height = mainSwiperFirstSlide.scrollHeight - 50 + 'px';
});

document.addEventListener('DOMContentLoaded', () => {
	window.dispatchEvent(new Event('resize'));
});
